
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6a1556bf&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BulkImportSection.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BulkImportSection.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6a1556bf!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BulkImportSection.vue"),
  /* scopeId */
  "data-v-6a1556bf",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/pricing-costs/BulkImportSection.vue
// module id = 680
// module chunks = 2